export default "<div class=\"Stars\"\n[attr.style]=\"sanitizer.bypassSecurityTrustStyle('--rating: ' + rating )\"\naria-label=\"Rating out of 5.\" ></div>\n"